import { CompletedTile } from ':cloud/widgets/buildQuest/CompletedTile';
import { LockedTile } from ':cloud/widgets/buildQuest/LockedTile';
import { TileProps } from ':cloud/widgets/buildQuest/types';
import { UnlockedTile } from ':cloud/widgets/buildQuest/UnlockedTile';

export function GameTile({
  id,
  pointValue,
  isUnlocked,
  isComplete,
  onPress,
  variant,
}: TileProps): React.ReactElement {
  if (!isUnlocked) {
    return <LockedTile />;
  }
  if (isComplete) {
    return <CompletedTile id={id} pointValue={pointValue} variant={variant} onPress={onPress} />;
  }
  return <UnlockedTile id={id} pointValue={pointValue} variant={variant} onPress={onPress} />;
}
